import React, { useState, useEffect } from 'react';
import algoliasearch from 'algoliasearch/lite'
import styled from 'styled-components';
import Header from '../components/Header';
import { db, auth } from '../util/firebaseApp'
import { doc, collection, getDocs, query, where, getDoc, getCountFromServer } from 'firebase/firestore'
import { onAuthStateChanged } from 'firebase/auth';
import { InstantSearch, SearchBox, InfiniteHits } from 'react-instantsearch-hooks-web'
import axios from 'axios'
import BankHitComponent from '../components/BankHitComponent';

const Account = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const [banks, setBanks] = useState([]);
    const [userStatus, setUserStatus] = useState(false);
    const [bankCount, setBankCount] = useState(0);
    const [userEmail, setUserEmail] = useState("");
    const [userRole, setUserRole] = useState("default");

    const searchClient = algoliasearch(
        "Q59KO8R6QB",
        "a62e4c804f7175521dc8b72e98062d7b"
    )

    const searchIndex = searchClient.initIndex("fr_django");

    const getUser = async () => {
        if (userEmail) {
            const docRef = doc(db, "users", userEmail);
            const docSnap = await getDoc(docRef);
    
            if (docSnap.exists()) {
                setUserRole(docSnap.data().role);
            }
        }
    }

    onAuthStateChanged(auth, (user) => {
        if (user) {
          setUserEmail(user.email);
          setUserStatus(true);
        } else {
          setUserStatus(false);
        }
    });

    const getAllBanks = async () => {
        var request = `${apiUrl}/bank/banks`;
        axios
            .get(request)
            .then((res) => {
                setBanks(res.data)
                setBankCount(res.data.length)
                console.log(res.data.length)
            })
            .catch((err) => {console.log(err)})
    }

    useEffect(() => {
        //console.log("User Role: " + userRole);
        if (userRole === "admin") {
            getAllBanks();
        }
    }, [userRole])

    useEffect(() => {
        getUser();
    }, [userEmail])

    return (
        <PageContainer>
            <Header />
            {
                userStatus ?
                <InfoRow>
                    <BankCountText>{bankCount} Clothes Banks in the Database</BankCountText>
                    <LoggedInStatusText>Logged in as: {userEmail}</LoggedInStatusText>
                </InfoRow>
                :
                ""
            }
            {
                userStatus ?
                <AddBankButton>
                    
                </AddBankButton> :
                ""
            }
            {
                userStatus ?
                <InstantSearch
                    searchClient={searchClient}
                    indexName='fr_django'
                >
                    <SearchHits>
                        <SearchBox placeholder="Search for banks..." />
                        <InfiniteHits hitComponent={BankHitComponent} />
                    </SearchHits>
                </InstantSearch> :
                <p>Not logged in</p>
            }
        </PageContainer>
    )
}

export default Account

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
`

const BankName = styled.h2`
    font-size: 24px;
    color: black;
`

const BankListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const BankListItem = styled.div`
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
`

const BankEditButton = styled.a`
    color: blue;
    font-weight: normal;
    margin: 24px 12px;
    font-size: 18px;
    text-decoration: none;
    display: block;
`

const AddBankButton = styled.div`
    margin: 24px 0 24px 0;

    a {
        text-decoration: none;
        font-size: 24px;
        border: 1px solid black;
        background: #fafafa;
        color: black;
        padding: 8px 16px;
    }

    a:hover {
        text-decoration: underline;
    }
`

const SearchHits = styled.div`

`

const BankCountText = styled.p`
    font-weight: 500;
    font-size: 26px;
    margin: 0;
`

const LoggedInStatusText = styled.p`
    color: black;
    margin: 0;
`

const InfoRow = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1280px;
    padding: 8px 20px;
    box-sizing: border-box;
`